import { render, staticRenderFns } from "./mySpace.vue?vue&type=template&id=4e6fe6c4&"
import script from "./mySpace.vue?vue&type=script&lang=js&"
export * from "./mySpace.vue?vue&type=script&lang=js&"
import style0 from "./mySpace.vue?vue&type=style&index=0&id=4e6fe6c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports